import React from 'react';
import styles from './ruleInfoModal.module.scss';
import Typography from 'src/components/typography/Typography';
import { TypographyVariants } from 'src/types/typography-variants.enum';
import LiteralsService from 'src/services/literals/LiteralsService';
import { trackClick } from 'src/hooks/useAdobeTags';
import adobeTags from 'src/types/adobe-tags';
import { useLocation } from 'react-router-dom';
import InfoModal from 'src/components/atomic/molecules/infoModal/InfoModal';

export default function RuleInfoModal(): JSX.Element {
    const { pathname } = useLocation();

    return (
        <InfoModal
            anchorTag={adobeTags.RuleInfoModal.Open}
            anchorTitle={LiteralsService.getLiteral('RuleInfoModal.anchorTitle')}
            id="rule-info-modal"
            title={LiteralsService.getLiteral('RuleInfoModal.title')}
            body={
                <>
                    <Typography variant={TypographyVariants.BODY_BOLD} component="h2">
                        {LiteralsService.getLiteral('RuleInfoModal.title')}
                    </Typography>
                    <ul className={styles.bulletPoints}>
                        <li>
                            <Typography variant={TypographyVariants.BODY}>
                                {LiteralsService.getLiteral('RuleInfoModal.point1')}
                            </Typography>
                        </li>
                        <li>
                            <Typography variant={TypographyVariants.BODY}>
                                {LiteralsService.getLiteral('RuleInfoModal.point2')}
                            </Typography>
                        </li>
                        <li>
                            <Typography variant={TypographyVariants.BODY}>
                                {LiteralsService.getLiteral('RuleInfoModal.point3')}
                            </Typography>
                        </li>
                    </ul>
                </>
            }
            onCloseClick={() => trackClick(pathname, adobeTags.RuleInfoModal.Close)}
        />
    );
}
